/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// State
import { TStore } from '@store/index';
import { StateCreator } from 'zustand';

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IMainSlice {
	module: string;
	setModule: (_module: string) => void;
	isOpenStartMint: boolean;
}

/* -------------------------------------------------------------------------- */
/*                                    Slice                                   */
/* -------------------------------------------------------------------------- */

const initialState = {
	module: '',
	isOpenStartMint: false,
};

export const createMainSlice: StateCreator<
	TStore,
	[],
	[],
	IMainSlice
> = (set) => ({
	...initialState,
	setModule: (_module: string) =>
		set({ module: _module }),
	setIsOpenStartMint: (_isOpenStartMint: boolean) =>
		set({ isOpenStartMint: _isOpenStartMint }),
});
